import React, { useState } from "react";
import cssClasses from "./ViewPayloadAndErrorDetailsModal.module.css";
import { Box, IconButton, Modal, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "../../../../Subcomponents/Button";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { successTost } from "../../../../Services/Toast";

function ViewPayloadAndErrorDetailsModal({
  open,
  handleClose,
  heading,
  displayMsg,
  copyFlag
}) {

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(193, 201, 210, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          <h1>{heading}</h1>
          {copyFlag && 
          <Tooltip title="Copy to Clipboard">
            <IconButton
              className={cssClasses.copyButton}
              onClick={() => {
                navigator.clipboard.writeText(displayMsg);
                successTost("Copied to clipboard!")
              }}>
              <ContentCopyIcon />
            </IconButton>
            </Tooltip>
          }
          <IconButton
            className={cssClasses.crossButton}
            onClick={() => handleClose()}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          {/* {displayMsg} */}
          <pre>{displayMsg === "Payload not available" || displayMsg === "Error not found" || displayMsg.includes("Digital-Cost-Sheet") 
                ?  displayMsg : JSON.stringify(JSON.parse(displayMsg), null, 2)}</pre>
        </div>

        <div className={cssClasses.footer}>
          <div>
            <Button
              style={{ color: "#344054", backgroundColor: "#ffffff" }}
              btnName={"Close"}
              clicked={() => handleClose()}
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ViewPayloadAndErrorDetailsModal;